// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/routes/Reminder/Reminder.css */

.reminder-head {
    color: #364C63;
    margin: 0;
    padding: 10px 12px 4px;
    font-size: 1.25rem;
    font-weight: 800;
    letter-spacing: 0;
    text-align: center;
}

.reminder-container {
    width: 100%;
    padding: 8px 10px 12px;
    overflow-y: auto;
    overflow-x: hidden;
}

.reminders-list {
    display: flex;
    gap: 12px;
    overflow-x: auto;
    overflow-y: hidden;
    padding: 4px 2px 10px;
    scrollbar-width: thin;
    scrollbar-color: #EF6F53 #edf1f5;
}

.reminders-list::-webkit-scrollbar {
    height: 8px;
}

.reminders-list::-webkit-scrollbar-track {
    background: #edf1f5;
    border-radius: 8px;
}

.reminders-list::-webkit-scrollbar-thumb {
    background: #EF6F53;
    border-radius: 8px;
}

.reminder-company-card {
    flex: 0 0 340px;
    height: calc(70vh - 20px);
    min-height: 360px;
    display: flex;
    flex-direction: column;
    border: 1px solid rgba(54, 76, 99, 0.12);
    border-radius: 8px;
    background: #ffffff;
    box-shadow: 0 12px 28px rgba(31, 46, 64, 0.08);
    overflow: hidden;
}

.reminder-company-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 10px 12px;
    background: #364C63;
    color: #ffffff;
}

.reminder-company-header h3 {
    margin: 0;
    font-size: 1rem;
    font-weight: 800;
    overflow-wrap: anywhere;
}

.reminder-company-header span {
    flex: 0 0 auto;
    min-width: 26px;
    padding: 3px 7px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.14);
    text-align: center;
    font-size: 0.78rem;
    font-weight: 800;
}

.company-reminders {
    flex: 1 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    padding: 8px;
    overflow-y: hidden;
    overflow-x: hidden;
}

.active-reminders,
.past-reminders {
    display: flex;
    flex-direction: column;
    gap: 8px;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: thin;
    scrollbar-color: rgba(54, 76, 99, 0.32) transparent;
}

.active-reminders {
    flex: 0 0 80%;
    max-height: 80%;
}

.past-reminders {
    flex: 0 0 20%;
    max-height: 20%;
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px dashed rgba(54, 76, 99, 0.16);
}

.past-reminders:empty {
    display: none;
}

.reminder-card {
    border: 1px solid rgba(54, 76, 99, 0.12);
    border-radius: 8px;
    padding: 9px;
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
}

.reminder-card:hover {
    transform: translateY(-1px);
    box-shadow: 0 8px 18px rgba(31, 46, 64, 0.12);
}

.reminder-card.later {
    background: #eaf7ef;
    border-color: #b7e2c6;
}

.reminder-card.soon {
    background: #fff2dd;
    border-color: #ffd49b;
}

.reminder-card.urgent {
    background: #ffe8e8;
    border-color: #ffb1b1;
}

.reminder-card.past {
    background: #edf0f3;
    border-color: #d4dbe3;
    color: #697789;
}

.reminder-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 8px;
}

.reminder-header h4 {
    margin: 0;
    color: #26384d;
    font-size: 0.92rem;
    font-weight: 800;
    overflow-wrap: anywhere;
}

.reminder-header span {
    flex: 0 0 auto;
    color: #52657a;
    font-size: 0.72rem;
    font-weight: 700;
    text-align: right;
}

.reminder-comment {
    margin: 6px 0 0;
    color: #4f6075;
    font-size: 0.82rem;
    line-height: 1.3;
    overflow-wrap: anywhere;
}

.error-message,
.no-reminders {
    padding: 18px;
    color: #66788f;
    text-align: center;
    border: 1px dashed rgba(54, 76, 99, 0.18);
    border-radius: 8px;
    background: #ffffff;
}

.error-message {
    color: #c0392b;
    background: #fff1f1;
    border-color: #f1bbbb;
}

@media (max-width: 720px) {
    .reminder-company-card {
        flex-basis: 290px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/routes/Other/Reminder/Reminder.css"],"names":[],"mappings":"AAAA,gDAAgD;;AAEhD;IACI,cAAc;IACd,SAAS;IACT,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB,gCAAgC;AACpC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,wCAAwC;IACxC,kBAAkB;IAClB,mBAAmB;IACnB,8CAA8C;IAC9C,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,qCAAqC;IACrC,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,mDAAmD;AACvD;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,6CAA6C;AACjD;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wCAAwC;IACxC,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,6EAA6E;AACjF;;AAEA;IACI,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,SAAS;IACT,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;;IAEI,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,yCAAyC;IACzC,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ","sourcesContent":["/* src/components/routes/Reminder/Reminder.css */\n\n.reminder-head {\n    color: #364C63;\n    margin: 0;\n    padding: 10px 12px 4px;\n    font-size: 1.25rem;\n    font-weight: 800;\n    letter-spacing: 0;\n    text-align: center;\n}\n\n.reminder-container {\n    width: 100%;\n    padding: 8px 10px 12px;\n    overflow-y: auto;\n    overflow-x: hidden;\n}\n\n.reminders-list {\n    display: flex;\n    gap: 12px;\n    overflow-x: auto;\n    overflow-y: hidden;\n    padding: 4px 2px 10px;\n    scrollbar-width: thin;\n    scrollbar-color: #EF6F53 #edf1f5;\n}\n\n.reminders-list::-webkit-scrollbar {\n    height: 8px;\n}\n\n.reminders-list::-webkit-scrollbar-track {\n    background: #edf1f5;\n    border-radius: 8px;\n}\n\n.reminders-list::-webkit-scrollbar-thumb {\n    background: #EF6F53;\n    border-radius: 8px;\n}\n\n.reminder-company-card {\n    flex: 0 0 340px;\n    height: calc(70vh - 20px);\n    min-height: 360px;\n    display: flex;\n    flex-direction: column;\n    border: 1px solid rgba(54, 76, 99, 0.12);\n    border-radius: 8px;\n    background: #ffffff;\n    box-shadow: 0 12px 28px rgba(31, 46, 64, 0.08);\n    overflow: hidden;\n}\n\n.reminder-company-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n    padding: 10px 12px;\n    background: #364C63;\n    color: #ffffff;\n}\n\n.reminder-company-header h3 {\n    margin: 0;\n    font-size: 1rem;\n    font-weight: 800;\n    overflow-wrap: anywhere;\n}\n\n.reminder-company-header span {\n    flex: 0 0 auto;\n    min-width: 26px;\n    padding: 3px 7px;\n    border-radius: 999px;\n    background: rgba(255, 255, 255, 0.14);\n    text-align: center;\n    font-size: 0.78rem;\n    font-weight: 800;\n}\n\n.company-reminders {\n    flex: 1;\n    min-height: 0;\n    display: flex;\n    flex-direction: column;\n    padding: 8px;\n    overflow-y: hidden;\n    overflow-x: hidden;\n}\n\n.active-reminders,\n.past-reminders {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    min-height: 0;\n    overflow-y: auto;\n    overflow-x: hidden;\n    scrollbar-width: thin;\n    scrollbar-color: rgba(54, 76, 99, 0.32) transparent;\n}\n\n.active-reminders {\n    flex: 0 0 80%;\n    max-height: 80%;\n}\n\n.past-reminders {\n    flex: 0 0 20%;\n    max-height: 20%;\n    margin-top: 8px;\n    padding-top: 8px;\n    border-top: 1px dashed rgba(54, 76, 99, 0.16);\n}\n\n.past-reminders:empty {\n    display: none;\n}\n\n.reminder-card {\n    border: 1px solid rgba(54, 76, 99, 0.12);\n    border-radius: 8px;\n    padding: 9px;\n    cursor: pointer;\n    transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;\n}\n\n.reminder-card:hover {\n    transform: translateY(-1px);\n    box-shadow: 0 8px 18px rgba(31, 46, 64, 0.12);\n}\n\n.reminder-card.later {\n    background: #eaf7ef;\n    border-color: #b7e2c6;\n}\n\n.reminder-card.soon {\n    background: #fff2dd;\n    border-color: #ffd49b;\n}\n\n.reminder-card.urgent {\n    background: #ffe8e8;\n    border-color: #ffb1b1;\n}\n\n.reminder-card.past {\n    background: #edf0f3;\n    border-color: #d4dbe3;\n    color: #697789;\n}\n\n.reminder-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 8px;\n}\n\n.reminder-header h4 {\n    margin: 0;\n    color: #26384d;\n    font-size: 0.92rem;\n    font-weight: 800;\n    overflow-wrap: anywhere;\n}\n\n.reminder-header span {\n    flex: 0 0 auto;\n    color: #52657a;\n    font-size: 0.72rem;\n    font-weight: 700;\n    text-align: right;\n}\n\n.reminder-comment {\n    margin: 6px 0 0;\n    color: #4f6075;\n    font-size: 0.82rem;\n    line-height: 1.3;\n    overflow-wrap: anywhere;\n}\n\n.error-message,\n.no-reminders {\n    padding: 18px;\n    color: #66788f;\n    text-align: center;\n    border: 1px dashed rgba(54, 76, 99, 0.18);\n    border-radius: 8px;\n    background: #ffffff;\n}\n\n.error-message {\n    color: #c0392b;\n    background: #fff1f1;\n    border-color: #f1bbbb;\n}\n\n@media (max-width: 720px) {\n    .reminder-company-card {\n        flex-basis: 290px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
